<script setup>
const props = defineProps(['action', 'story'])
const emits = defineEmits(['action'])
const route = useRoute()
const { t } = useI18n()
</script>

<template>
  <div>
    <div class="max-w-full w-full flex flex-wrap items-center justify-between gap-4 rounded-md bg-white p-5 shadow-custom-2xl shadow-shadow-light/10 lg:block lg:w-full">
      <h3 class="text-xl font-bold leading-7 lg:mb-3">
        <span>{{ t('button.submit_app') }}</span>
      </h3>
      <div class="hidden w-full flex-wrap gap-y-4 lg:flex lg:flex-col">
        <!-- <div class="flex flex-auto flex-row items-center gap-x-5">
          <div class="h-[45px] w-[45px] flex items-center justify-center rounded-full bg-slate-100">
            <svg class="text-blue-500" width="23" height="23" viewBox="0 0 256 256"><path fill="currentColor" d="M128 64a40 40 0 1 0 40 40a40 40 0 0 0-40-40Zm0 64a24 24 0 1 1 24-24a24 24 0 0 1-24 24Zm0-112a88.1 88.1 0 0 0-88 88c0 31.4 14.51 64.68 42 96.25a254.19 254.19 0 0 0 41.45 38.3a8 8 0 0 0 9.18 0a254.19 254.19 0 0 0 41.37-38.3c27.45-31.57 42-64.85 42-96.25a88.1 88.1 0 0 0-88-88Zm0 206c-16.53-13-72-60.75-72-118a72 72 0 0 1 144 0c0 57.23-55.47 105-72 118Z" /></svg>
          </div>
          <div class="flex flex-col text-md">
            <span class="text-primary/90 font-semibold capitalize">{{ t('career.location.title') }}</span>
            <slot name="location" />
          </div>
        </div> -->
        <div class="flex flex-auto flex-row items-center gap-x-5">
          <div class="h-[45px] w-[45px] flex items-center justify-center rounded-full bg-slate-100">
            <svg class="text-blue-500" width="23" height="23" viewBox="0 0 24 24"><path fill="currentColor" d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0 0 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7z" /></svg>
          </div>
          <div class="flex flex-col text-md">
            <span class="text-primary/90 font-semibold capitalize">{{ t('career.workingModel.title') }}</span>
            <slot name="time" />
          </div>
        </div>
        <div class="flex flex-auto flex-row items-center gap-x-5">
          <div class="h-[45px] w-[45px] flex items-center justify-center rounded-full bg-slate-100">
            <svg class="text-blue-500" width="23" height="23" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><circle cx="17" cy="7" r="3" /><circle cx="7" cy="17" r="3" /><path d="M14 14h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5ZM4 4h6v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4Z" /></g></svg>
          </div>
          <div class="flex flex-col text-md">
            <span class="text-primary/90 font-semibold capitalize">{{ t('career.category.title') }}</span>
            <slot name="categories" />
          </div>
        </div>
      </div>
      <div class="flex flex-row items-center gap-3 lg:mt-custom-lg">
        <div class="flex-auto text-center lg:w-full lg:flex md:flex-initial">
          <button
            type="button"
            class="w-full flex cursor-pointer cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-blue-500 px-4 py-3 text-sm text-white font-semibold ring-blue-500/25 transition duration-200 ease-out md:text-md hover:ring-4"
            @click="emits('action')"
          >
            <span>{{ t('button.apply') }}</span>
          </button>
        </div>
        <div class="flex-auto text-center lg:w-full lg:flex md:flex-initial">
          <UISocialShare
            classes="!right-0 !left-unset"
            :content="{
              link: route.path,
              title: story.title,
              msg: 'DEXON Technology PLC is a leading technology company providing non-destructive testing, in-line inspection, and asset integrity management services globally.',
            }"
          >
            <template #default>
              <div
                class="w-full flex cursor-default cursor-pointer items-center justify-center whitespace-nowrap border border-blue-500 rounded-md px-4 py-3 text-sm text-blue-500 font-semibold ring-blue-500/25 transition duration-200 ease-out hover:ring-4"
              >
                <span>{{ t('button.share') }}</span>
              </div>
            </template>
          </UISocialShare>
        </div>
      </div>
    </div>
  </div>
</template>
